import React from "react";
import { useAuth } from "@/context/AuthContext";
import { X } from "lucide-react";

// Ad banner shown to free / anonymous users. Hidden for premium members.
export function AdBanner({ slot = "leaderboard", className = "" }) {
  const { user } = useAuth();
  if (user && user.is_premium) return null;

  return (
    <div
      data-testid={`ad-banner-${slot}`}
      className={`relative border-2 border-dashed border-zinc-700 bg-zinc-900/60 rounded-lg overflow-hidden ${className}`}
    >
      <span className="absolute top-1 right-2 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
        Ad
      </span>
      <div className="flex items-center justify-center gap-3 py-4 px-4 text-center">
        <span className="text-zinc-400 text-sm">
          Tired of ads?{" "}
          <a href="/subscribe" className="text-neon-cyan font-semibold hover:underline">
            Go Premium for an ad-free experience →
          </a>
        </span>
      </div>
    </div>
  );
}

export function AdSidebar() {
  const { user } = useAuth();
  if (user && user.is_premium) return null;
  return (
    <div
      data-testid="ad-banner-sidebar"
      className="relative border-2 border-dashed border-zinc-700 bg-zinc-900/60 rounded-lg h-64 flex items-center justify-center"
    >
      <span className="absolute top-1 right-2 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">Ad</span>
      <span className="text-zinc-500 text-sm font-mono">Your ad here</span>
    </div>
  );
}
